import { z } from "zod";

import {
  addressSchema,
  dateString,
  optionalEmail,
  optionalPhone,
  optionalText
} from "@/lib/forms/schema";

import type { IndividualEditValues } from "../../api/individuals";

/** Light validation for Case Settings: formats only, nothing is required. */
export const caseSettingsSchema: z.ZodType<
  IndividualEditValues,
  IndividualEditValues
> = z.object({
  firstName: optionalText(),
  middleName: optionalText(),
  lastName: optionalText(),
  title: optionalText(),
  pronouns: optionalText(),
  dob: dateString(),
  countryOfBirth: optionalText(),
  countryOfCitizenship: optionalText(),
  email: optionalEmail(),
  phone: optionalPhone(),
  visaType: optionalText(),
  isRfe: z.boolean(),
  physicalAddress: addressSchema(),
  mailingAddress: addressSchema(),
  similarAddress: z.boolean(),
  employerInfo: z.object({
    legalBusinessName: optionalText(),
    dba: optionalText(),
    contactName: optionalText(),
    contactTitle: optionalText(),
    contactEmail: optionalEmail(),
    contactPhone: optionalPhone(),
    businessAddress: addressSchema()
  }),
  employerPetitioner: z.boolean()
});
